const initModals = () => {
  const modals = document.querySelectorAll('.js-modal');
  const togglers = document.querySelectorAll('.js-modal-toggle');

  if (modals.length && togglers.length) {
    const showModal = (modal) => {
      document.body.classList.add('disable-scroll');
      modal.classList.remove('modal--hide');
    };

    const closeModal = (modal) => {
      document.body.classList.remove('disable-scroll');
      modal.classList.add('modal--hide');
    };

    const bindCloseModal = (element, modal) => {
      if (element && !element.dataset.modalBound) {
        element.dataset.modalBound = 'true'; // eslint-disable-line no-param-reassign
        element.addEventListener('click', (event) => {
          event.preventDefault();
          closeModal(modal);
        });
      }
    };

    const bindEscapeKeyOnHide = (modal) => {
      if (!modal.dataset.escapeBound) {
        modal.dataset.escapeBound = 'true'; // eslint-disable-line no-param-reassign
        window.addEventListener('keyup', (e) => {
          if (e.key === 'Escape' || e.key === 'Esc' || e.code === 27 || e.code === 53) {
            e.preventDefault();
            closeModal(modal);
          }

          return false;
        }, true);
      }
    };

    [...togglers].forEach((toggler) => {
      if (toggler.dataset.modalBound) return;
      toggler.dataset.modalBound = 'true'; // eslint-disable-line no-param-reassign

      toggler.addEventListener('click', (event) => {
        event.preventDefault();
        // Look up modal at click time to handle dynamic content
        const modalId = toggler.getAttribute('data-target');
        const modal = document.getElementById(modalId);
        if (modal) showModal(modal);
      });
    });

    [...modals].forEach((modal) => {
      bindEscapeKeyOnHide(modal);
      bindCloseModal(modal.querySelector('.js-modal-close-icon'), modal);
      bindCloseModal(modal.querySelector('.js-modal-close-button'), modal);
      bindCloseModal(modal.querySelector('.js-modal-backdrop'), modal);
    });
  }
};

// Support both initial page load and Turbo navigation
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initModals);
} else {
  // DOM already loaded, run immediately
  initModals();
}
document.addEventListener('turbo:load', initModals);
